import Submit from '~/components/button/Submit';
import CustomField from '~/components/CustomField';
import Form from '~/components/Form';
import Field from '~/components/form-controls/Field';
import FileUploader from '~/components/form-controls/FileUploader';
import TextArea from '~/components/form-controls/TextArea';
import Page from '~/components/layout/page/Page';
import { FormKeys, useActionResult, useLoaderData } from './claimLineItemMeta';

export default function ClaimLineItemMetaPage() {
  const {
    claim,
    customFields,
    showDefaultCommentField,
    mediaUploadInstructions,
    mediaAcceptTypes,
    assets,
    requiredMediaCount,
    isDefaultCommentFieldRequired,
    uploadFileInfo,
  } = useLoaderData();

  const actionResult = useActionResult();
  const hasErrors = actionResult && !actionResult.ok;
  const customFieldsExist = customFields.length > 0;

  return (
    <Page.Section
      title={
        customFieldsExist
          ? `Let's get some more information`
          : 'Anything else you can tell us?'
      }
    >
      <Form encType="multipart/form-data" name="claimMeta">
        {customFields.map((field) => (
          <CustomField
            key={field.id}
            field={field}
            defaultValue={claim.customFields[field.id]?.value}
          />
        ))}

        {showDefaultCommentField && (
          <TextArea
            id="comments"
            name={FormKeys.Comments}
            defaultValue={claim.comments ?? ''}
            required={Boolean(isDefaultCommentFieldRequired)}
            label="Additional comments"
          />
        )}

        <FileUploader
          name={FormKeys.Assets}
          label="Upload files"
          defaultValue={assets}
          min={requiredMediaCount}
          description={mediaUploadInstructions}
          accept={mediaAcceptTypes}
          destination={uploadFileInfo.destination}
          storefrontId={uploadFileInfo.storefrontId}
        />

        {hasErrors && <Field.ErrorText>{actionResult.message}</Field.ErrorText>}

        <input
          type="hidden"
          data-testid="required-asset-count"
          name={FormKeys.RequiredAssetCount}
          value={String(requiredMediaCount)}
        />

        <Submit>Next</Submit>
      </Form>
    </Page.Section>
  );
}
